import axios from "axios";

// Clave de almacenamiento del consentimiento (Ley 21.719).
// Si cambia la estructura, subir la versión para volver a pedir consentimiento.
export const CONSENT_STORAGE_KEY = "pc_cookie_consent_v1";

export interface CookieConsent {
    analiticas: boolean;
    marketing: boolean;
    fecha: string; // ISO 8601
    version: number;
}

declare global {
    interface Window {
        pcApplyCookieConsent?: (consent: CookieConsent) => void;
    }
}

export const getStoredConsent = (): CookieConsent | null => {
    try {
        const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed?.analiticas !== "boolean" || typeof parsed?.marketing !== "boolean") {
            return null;
        }
        return parsed as CookieConsent;
    } catch {
        return null;
    }
};

export const saveConsent = (prefs: { analiticas: boolean; marketing: boolean }): CookieConsent => {
    const consent: CookieConsent = {
        analiticas: prefs.analiticas,
        marketing: prefs.marketing,
        fecha: new Date().toISOString(),
        version: 1,
    };

    try {
        localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
    } catch {
        // localStorage no disponible (modo incógnito extremo): el banner volverá a aparecer.
    }

    // Carga/actualiza los scripts de tracking según lo consentido (definido en app.blade.php).
    window.pcApplyCookieConsent?.(consent);

    // Registro de evidencia del consentimiento (Ley 21.719) — fire & forget.
    axios
        .post(`${window.origin}/api/consentimiento-cookies`, {
            analiticas: consent.analiticas,
            marketing: consent.marketing,
        })
        .catch(() => {
            /* el registro es evidencia, no debe bloquear la navegación */
        });

    return consent;
};

// Evento global para reabrir las preferencias desde cualquier parte (ej. footer).
export const OPEN_PREFERENCES_EVENT = "pc:abrir-preferencias-cookies";

export const openCookiePreferences = () => {
    window.dispatchEvent(new CustomEvent(OPEN_PREFERENCES_EVENT));
};
